export const SET_ORDER = "SET_ORDER";
export const SET_ORDERS = "SET_ORDERS";
export const ADD_ORDER = "ADD_ORDER";
export const UPDATE_ORDER = "UPDATE_ORDER";
export const REMOVE_ORDER = "REMOVE_ORDER";
export const UNSUBSCRIBE_GET_ORDER = "UNSUBSCRIBE_GET_ORDER";
export const UNSUBSCRIBE_GET_ALL_ORDERS = "UNSUBSCRIBE_GET_ALL_ORDERS";
export const SET_CART = "SET_CART";
export const ADD_CART_PRODUCT = "ADD_CART_PRODUCT";
export const REMOVE_CART_PRODUCT = "REMOVE_CART_PRODUCT";
export const SET_CART_IGV = "SET_CART_IGV";
